export default __webpack_public_path__ + "static/media/phone-call.1164dc9a.svg";